<template>
    <div class="token-line-container">
        <div class="token-line__item token-line__big-item">{{ token.date }}</div>
        <div class="token-line__item token-line__big-item">{{ getTokenTypeText(token.type) }}</div>
        <div class="token-line__item token-line__big-item">{{ token.code }}</div>
        <div class="token-line__item token-line__little-item token-line__amount">
            <div class="token-line__amount__label">{{ getCurrency() }}</div>
            <input
                v-model.number="token.amount"
                class="token-line__amount__input"
                :class="{
                    'token-line__amount__input--disabled': token.paid,
                    'token-line__amount__input--active': !token.paid,
                }"
                type="number"
                :disabled="token.paid"
                @keypress="isNumber($event)"
            />
        </div>
        <div class="token-line__item token-line__tiny-item">
            <div
                class="token-line__checkBox sg-custom-toggle sg-checkmark"
                :class="{ 'token-line__checkBox--active': token.paid }"
            >
                <label>
                    <input v-model="token.paid" type="checkbox" :disabled="false" />
                    <div
                        class="token-line__check"
                        :class="{
                            'token-line__check--active': token.paid,
                            'token-line__check--passive': !token.paid,
                        }"
                    >
                        <div class="sg-vrm-icon_054_check-16px" />
                    </div>
                    <div class="sg-caption-container">
                        <div class="sg-caption"></div>
                    </div>
                </label>
            </div>
        </div>
        <div class="token-line__item token-line__big-item">{{ token.author }}</div>
    </div>
</template>
<style></style>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import VrmToggleCheckmark from '@/vue/components/shared/toggles/VrmToggleCheckmark';
import VrmToggle from '@/vue/components/shared/toggles/VrmToggle';
import CurrencyMap from '@/utils/currency.js';
@Component({
    components: {
        VrmToggleCheckmark,
        VrmToggle,
        CurrencyMap,
    },
})
export default class VrmPaygoTokenHistoryLine extends Vue {
    @Prop()
    token;

    getCurrency() {
        return CurrencyMap[this.token.currency];
    }

    getTokenTypeText(type) {
        switch (type) {
            case 'set_time':
                return 'Set Time';
            case 'add_time':
                return 'Add Time';
            case 'disable':
                return 'Disable PAYGo';
            default:
                return 'Invalid Token Type';
        }
    }

    isNumber(evt) {
        evt = evt ? evt : window.event;
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
            evt.preventDefault();
        } else {
            return evt;
        }
    }
}
</script>
